import { type Control, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import DoorFrontIcon from '@mui/icons-material/DoorFront';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type DoorTypesDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const DoorTypesDetails = ({ control }: DoorTypesDetailsProps) => {
  const { envelope } = useWatch({ control });
  const doorTypes = envelope?.doorTypes ?? [];

  const entryCount = doorTypes.length;
  const attachmentCount = doorTypes.reduce(
    (sum, entry) => sum + (entry.attachments?.length ?? 0),
    0,
  );

  const items = [
    {
      label: 'Entries',
      value: entryCount > 0 ? String(entryCount) : undefined,
    },
    {
      label: 'Attachments',
      value: attachmentCount > 0 ? String(attachmentCount) : undefined,
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <DoorFrontIcon fontSize="inherit" />
            <span>&nbsp;Door types</span>
          </Grid>
        </Typography>
        {items.map(({ label, value }) => (
          <Grid key={label} container justifyContent="space-between">
            <Typography component="span" variant="body2">
              {label}:
            </Typography>
            <Typography
              component="span"
              variant="body2"
              color={isNil(value) ? 'textDisabled' : 'textPrimary'}>
              {isNil(value) ? '—' : value}
            </Typography>
          </Grid>
        ))}
        <Divider />
      </Stack>
    </Box>
  );
};
